var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.942 22.942C11.5263 23.5263 12.4737 23.5263 13.058 22.942C13.6419 22.3581 13.6423 21.4115 13.0589 20.827L5.745 13.5L22.5 13.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5L5.745 10.5L13.0636 3.19452C13.6524 2.60676 13.6528 1.65282 13.0645 1.06452C12.4766 0.476603 11.5234 0.476603 10.9355 1.06452L1.41421 10.5858C0.633165 11.3668 0.633165 12.6332 1.41421 13.4142L10.942 22.942Z",
    fill: "#292E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.eff8ac0e.svg";
export { ForwardRef as ReactComponent };